// extracted by mini-css-extract-plugin
export default {"root":"CustomizationSKU_root__ZB6T1","form-control-label":"CustomizationSKU_form-control-label__4Of55","switch":"CustomizationSKU_switch__ADwKI"};